import { cn } from "@/utils/cn";
import { memo } from "react";

interface HamburgerIconProps {
  className?: string;
}

export const HamburgerIcon = memo(function HamburgerIcon({ className }: HamburgerIconProps) {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
    >
      <path d="M18 9.5C18 9.69155 17.9254 9.87525 17.7925 10.0107C17.6597 10.1461 17.4795 10.2222 17.2917 10.2222H1.70833C1.52047 10.2222 1.3403 10.1461 1.20747 10.0107C1.07463 9.87525 1 9.69155 1 9.5C1 9.30845 1.07463 9.12475 1.20747 8.98931C1.3403 8.85387 1.52047 8.77778 1.70833 8.77778H17.2917C17.4795 8.77778 17.6597 8.85387 17.7925 8.98931C17.9254 9.12475 18 9.30845 18 9.5ZM1.70833 4.44444H17.2917C17.4795 4.44444 17.6597 4.36835 17.7925 4.23291C17.9254 4.09747 18 3.91377 18 3.72222C18 3.53068 17.9254 3.34698 17.7925 3.21153C17.6597 3.07609 17.4795 3 17.2917 3H1.70833C1.52047 3 1.3403 3.07609 1.20747 3.21153C1.07463 3.34698 1 3.53068 1 3.72222C1 3.91377 1.07463 4.09747 1.20747 4.23291C1.3403 4.36835 1.52047 4.44444 1.70833 4.44444ZM17.2917 14.5556H1.70833C1.52047 14.5556 1.3403 14.6316 1.20747 14.7671C1.07463 14.9025 1 15.0862 1 15.2778C1 15.4693 1.07463 15.653 1.20747 15.7885C1.3403 15.9239 1.52047 16 1.70833 16H17.2917C17.4795 16 17.6597 15.9239 17.7925 15.7885C17.9254 15.653 18 15.4693 18 15.2778C18 15.0862 17.9254 14.9025 17.7925 14.7671C17.6597 14.6316 17.4795 14.5556 17.2917 14.5556Z" fill="black"/>
    </svg>
  );
});